<template>
  <v-row dense class="mt-4">
    <v-col cols="12" class="my-0 pb-0">
      <div class="d-flex">
        <div
          v-if="el.color != ''"
          class="circle mr-2"
          :style="{ backgroundColor: el.color }"
        >
          {{ el.label }}
        </div>
        <div class="text">
          <h2 :class="computedSize" class="mb-0 text-h4">
            {{ el.name }}
          </h2>
        </div>
      </div>
    </v-col>
    <v-col v-if="el.sentence" cols="12">
      <p class="text-h6 font-weight-regular mb-0 mt-0">
        {{ el.sentence }}
      </p></v-col
    >
  </v-row>
</template>

<script>
export default {
  name: "ColHeader",
  data() {
    return {};
  },
  props: {
    el: {
      required: true,
      type: Object,
      default: () => ({}),
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
    depthInc: Number,
  },
  computed: {
    computedSize() {
      if (this.attrs.type === "large") {
        return "text-h5";
      }
      if (this.attrs.type === "medium") {
        return "text-h6";
      }
      if (this.attrs.type === "small") {
        return "text-body-1";
      }
      if (this.attrs.type === "waterfall") {
        switch (this.depthInc) {
          case 1:
            return "text-h5";
          case 2:
            return "text-h6";
          case 3:
            return "text-body-1";
          default:
            return "text-body-2";
        }
      }
      return "text-h5";
    },
  },
};
</script>

<style lang="scss" scoped>
.circle {
  width: 30px;
  max-width: 30px;
  max-height: 30px;
  height: 30px;
  background: grey;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
  flex: 1;
}
.text {
  flex: 1;
  h2 {
    line-height: 1.4;
    padding-bottom: 1rem;
  }
}
.pre-wrap {
  white-space: pre-wrap;
}
</style>
